import Icon from '../components/Icon.vue'

Icon.register({"barcode":{"width":512,"height":512,"paths":[{"d":"M0 448V64H18V448H0zM26.9 447.7V64H36V447.7H26.9zM54 447.7V64H62.9V447.7H54zM98.9 447.7V64H107.7V447.7H98.9zM134.9 447.7V64H152.6V447.7H134.9zM179.7 447.7V64H188.6V447.7H179.7zM197.7 447.7V64H206.6V447.7H197.7zM215.7 447.7V64H224.6V447.7H215.7zM251.4 447.7V64H269.4V447.7H251.4zM296.3 447.7V64H314.3V447.7H296.3zM332.3 447.7V64H350.3V447.7H332.3zM368.3 447.7V64H386.3V447.7H368.3zM395.1 447.7V64H413.1V447.7H395.1zM440.3 447.7V64H467.1V447.7H440.3zM476 447.7V64H485.1V447.7H476zM494 448V64H512V448H494z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/barcode.js
// module id = mrqo
// module chunks = 0